
export default function Registration() {
  return (
    <section id="inscripcion" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Información de <span className="text-red-600">Inscripción</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Todo lo que necesitas saber para participar en la XX San Silvestre Zaragoza El Rincón 2025.
          </p>
        </div>

        {/* Registration Info Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* Pricing */}
          <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-3xl p-8 border border-red-200">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mr-4">
                <i className="ri-price-tag-3-line text-xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Precios de Inscripción</h3>
            </div>
            <div className="space-y-4">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-semibold text-gray-900">Hasta el 1 de diciembre</p>
                    <p className="text-sm text-gray-600">Precio anticipado</p>
                  </div>
                  <div className="text-right">
                    <p className="text-3xl font-bold text-red-600">14€</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-semibold text-gray-900">A partir del 2 de diciembre</p>
                    <p className="text-sm text-gray-600">Precio regular</p>
                  </div>
                  <div className="text-right">
                    <p className="text-3xl font-bold text-red-600">16€</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Important Dates */}
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-3xl p-8 border border-blue-200">
            <div className="flex items-center mb-6">
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                <i className="ri-calendar-check-line text-xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900">Fechas Importantes</h3>
            </div>
            <div className="space-y-4">
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center">
                  <i className="ri-play-circle-line text-2xl text-green-600 mr-3"></i>
                  <div>
                    <p className="font-semibold text-gray-900">Apertura de inscripciones</p>
                    <p className="text-sm text-gray-600">17 de noviembre a las 9:00h</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center">
                  <i className="ri-stop-circle-line text-2xl text-red-600 mr-3"></i>
                  <div>
                    <p className="font-semibold text-gray-900">Cierre de inscripciones</p>
                    <p className="text-sm text-gray-600">26 de diciembre a las 23:59h</p>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center">
                  <i className="ri-group-line text-2xl text-orange-600 mr-3"></i>
                  <div>
                    <p className="font-semibold text-gray-900">Límite de participantes</p>
                    <p className="text-sm text-gray-600">Máximo 5.000 inscritos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Registration Methods */}
        <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-3xl p-8 border border-purple-200 mb-8">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mr-4">
              <i className="ri-store-2-line text-xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900">Puntos de Inscripción</h3>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="flex items-start">
                <i className="ri-global-line text-2xl text-purple-600 mr-3 mt-1"></i>
                <div>
                  <p className="font-semibold text-gray-900 mb-2">Inscripción Online</p>
                  <p className="text-gray-700 text-sm">A través de AvaiBookSports.com</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-2xl text-purple-600 mr-3 mt-1"></i>
                <div>
                  <p className="font-semibold text-gray-900 mb-2">RunningZgz</p>
                  <p className="text-gray-700 text-sm">Calle Ricla, 2, Zaragoza</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="flex items-start">
                <i className="ri-map-pin-line text-2xl text-purple-600 mr-3 mt-1"></i>
                <div>
                  <p className="font-semibold text-gray-900 mb-2">Zenit Deportes</p>
                  <p className="text-gray-700 text-sm">Calle María Guerrero, 14, Zaragoza</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Solidarity Component */}
        <div className="bg-gradient-to-br from-pink-50 to-pink-100 rounded-3xl p-8 border border-pink-200 mb-8">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 bg-pink-600 rounded-full flex items-center justify-center mr-4">
              <i className="ri-heart-line text-xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900">Componente Solidario</h3>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-sm">
            <p className="text-gray-700 mb-4 leading-relaxed">
              Por cada inscripción realizada, se donará:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex items-start">
                <i className="ri-heart-fill text-2xl text-pink-600 mr-3 mt-1"></i>
                <div>
                  <p className="font-semibold text-gray-900">1€ a AFEDA</p>
                  <p className="text-sm text-gray-600">Asociación de Familiares de Enfermos de Alzheimer</p>
                </div>
              </div>
              <div className="flex items-start">
                <i className="ri-heart-fill text-2xl text-pink-600 mr-3 mt-1"></i>
                <div>
                  <p className="font-semibold text-gray-900">1€ a Parkinson Aragón</p>
                  <p className="text-sm text-gray-600">Asociación Parkinson de Aragón</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bib Collection Section */}
        <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-3xl p-8 border border-green-200">
          <div className="flex items-center mb-6">
            <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mr-4">
              <i className="ri-t-shirt-line text-xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900">Recogida de dorsales</h3>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <div className="bg-white rounded-xl p-6 shadow-sm mb-6">
                <div className="flex items-start">
                  <i className="ri-map-pin-2-line text-2xl text-green-600 mr-3 mt-1"></i>
                  <div>
                    <p className="font-semibold text-gray-900 mb-2">Lugar de recogida</p>
                    <p className="text-gray-700">Centro Cívico La Almozara</p>
                    <p className="text-sm text-gray-600 mt-1">
                      Recogida de dorsales y camiseta únicamente en este lugar
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <i className="ri-calendar-line text-xl text-green-600 mr-3"></i>
                      <div>
                        <p className="font-semibold text-gray-900">29 de diciembre</p>
                        <p className="text-sm text-gray-600">Lunes</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="font-semibold text-gray-900">14:00 - 20:00h</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <i className="ri-calendar-line text-xl text-green-600 mr-3"></i>
                      <div>
                        <p className="font-semibold text-gray-900">30 de diciembre</p>
                        <p className="text-sm text-gray-600">Martes</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="font-semibold text-gray-900">10:00 - 20:00h</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6">
                <div className="flex items-start">
                  <i className="ri-information-line text-2xl text-yellow-600 mr-3 mt-1"></i>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-3">Documentación necesaria</h4>
                    <p className="text-gray-700 mb-4">
                      Para recoger tu dorsal y camiseta debes presentar:
                    </p>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-center">
                        <i className="ri-check-line text-green-600 mr-2"></i>
                        DNI original
                      </li>
                      <li className="flex items-center">
                        <i className="ri-check-line text-green-600 mr-2"></i>
                        Cualquier documento acreditativo válido
                      </li>
                    </ul>
                    <p className="text-sm text-gray-600 mt-4 font-medium">
                      ⚠️ Es imprescindible presentar documentación para la recogida
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="text-center mt-12">
          <a 
            href="https://www.avaibooksports.com/inscripcion/xx-san-silvestre-zaragoza-el-rincon-2025/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-8 py-4 bg-red-600 text-white font-bold text-lg rounded-full hover:bg-red-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line mr-3 text-xl"></i>
            ¡Inscríbete Ahora!
          </a>
          <p className="text-gray-600 mt-4">
            Inscripción a través de AvaiBookSports.com
          </p>
        </div>
      </div>
    </section>
  );
}
